import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type FeatureConfigService from 'garaje/services/feature-config';
import type StateService from 'garaje/services/state';

export interface ResourcesResourceTypeLandingRouteModel {
  resourceTypeId: string;
}

export default class ResourcesResourceTypeLandingRoute extends Route {
  @service declare router: RouterService;
  @service declare abilities: AbilitiesService;
  @service declare featureConfig: FeatureConfigService;
  @service declare state: StateService;

  beforeModel(): void {
    const resourceTypeId = this.currentResourceTypeId;

    if (resourceTypeId !== '1') {
      return void this.router.transitionTo('unauthorized');
    }

    if (this.abilities.cannot('visit-landing desks')) {
      return void this.router.transitionTo('unauthorized');
    }

    if (this.featureConfig.isEnabled('desks') && !!this.state.currentLocationEnabledDesks?.active) {
      return void this.router.transitionTo('resources.resource-type.index', 1);
    }
  }

  model(): ResourcesResourceTypeLandingRouteModel {
    const resourceTypeId = this.currentResourceTypeId;

    return {
      resourceTypeId,
    };
  }

  get currentResourceTypeId(): string {
    const { resource_type_id } = this.paramsFor('resources.resource-type') as {
      resource_type_id: string;
    };

    return resource_type_id;
  }
}
